module.exports = __webpack_public_path__ + "img/hohlschnitt_enzianblau_ral5010.2a816292.jpg";